import { memo } from "react";
import PropTypes from "prop-types";

import TabButton from "../../formInputs/buttons/TabButton";

const SubjectTabs = memo(function SubjectTabs({
    disabled,
    onSelect,
    selectedSubjectId,
    schoolLevelExpectations,
    sleTabsEnabled = false,
    subjectOptions,
    view
}) {
    if (!subjectOptions?.length) return null;
    const shouldShowSle =
        (view !== "GROUPS" && schoolLevelExpectations.length > 0) || (view === "GROUPS" && sleTabsEnabled);
    return (
        <section className="subject-hub">
            <div className="subject-hub__header">
                <span className="subject-hub__label">Selected subject</span>
            </div>
            <div className="subject-hub__tabs">
                {shouldShowSle && (
                    <TabButton
                        key="SLE"
                        className={selectedSubjectId === "SLE" ? "tab-button-selected" : "tab-button"}
                        onClick={() => onSelect("SLE")}
                        disable={disabled}
                        aria-pressed={selectedSubjectId === "SLE"}
                        size="small-no-width"
                    >
                        <p className="primary">SLE</p>
                    </TabButton>
                )}
                {subjectOptions.map((subject) => {
                    const isSelected = Number(selectedSubjectId) === Number(subject.templateId);
                    return (
                        <TabButton
                            key={subject.templateId}
                            className={isSelected ? "tab-button-selected" : "tab-button"}
                            onClick={() => onSelect(subject)}
                            disable={disabled}
                            aria-pressed={isSelected}
                            size="small-no-width"
                        >
                            <p className="primary">{subject.subjectName}</p>
                        </TabButton>
                    );
                })}
            </div>
        </section>
    );
});

SubjectTabs.propTypes = {
    disabled: PropTypes.bool,
    onSelect: PropTypes.func.isRequired,
    schoolLevelExpectations: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            expectation: PropTypes.string.isRequired,
            sleChildList: PropTypes.arrayOf(
                PropTypes.shape({
                    key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
                    expectation: PropTypes.string.isRequired
                })
            )
        })
    ),
    selectedSubjectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    sleTabsEnabled: PropTypes.bool,
    subjectOptions: PropTypes.arrayOf(
        PropTypes.shape({
            templateId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            subjectName: PropTypes.string.isRequired
        })
    ).isRequired,
    view: PropTypes.string.isRequired
};

export default SubjectTabs;
